export const CHANGE_EXHIBITORS_FILTER = 'CHANGE_EXHIBITORS_FILTER';

export const CHANGE_MEDIA_PARTNERS_FILTER = 'CHANGE_MEDIA_PARTNERS_FILTER';

export const CHANGE_ROUND_TABLES_FILTER = 'CHANGE_ROUND_TABLES_FILTER';

export const CHANGE_PERSONALITIES_FILTER = 'CHANGE_PERSONALITIES_FILTER';

export const CHANGE_DATE = 'CHANGE_DATE';

export const CHANGE_LOCALE = 'CHANGE_LOCALE';

export const TOGGLE_MENU = 'TOGGLE_MENU';



/** WEBPACK FOOTER **
 ** ./src/actions/actionTypes.js
 **/